/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Category_SmartwatchesInputs */

const he_home_category_smartwatches = /** @type {(inputs: Home_Category_SmartwatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שעונים חכמים`)
};

const en_home_category_smartwatches = /** @type {(inputs: Home_Category_SmartwatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Smartwatches`)
};

/**
* | output |
* | --- |
* | "Smartwatches" |
*
* @param {Home_Category_SmartwatchesInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const home_category_smartwatches = /** @type {((inputs?: Home_Category_SmartwatchesInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Category_SmartwatchesInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_home_category_smartwatches(inputs)
	return en_home_category_smartwatches(inputs)
});